type ColorSchemeSetting = 'auto' | 'light' | 'dark'
type ContrastSetting = 'auto' | 'default' | 'increased'
type Theme = 'vet' | 'vet-high-contrast' | 'vet-dark' | 'vet-dark-high-contrast'

const colorSchemeSetting = ref<ColorSchemeSetting>('light')
const contrastSetting = ref<ContrastSetting>('default')

const preferredColorScheme = usePreferredColorScheme()
const preferredContrast = usePreferredContrast()

const themeMap = {
  light: {
    increased: 'vet-high-contrast',
    default: 'vet',
  },
  dark: {
    increased: 'vet-dark-high-contrast',
    default: 'vet-dark',
  },
} as const

const theme = computed<Theme>(() => {
  const colorScheme =
    colorSchemeSetting.value === 'auto'
      ? preferredColorScheme.value === 'dark'
        ? 'dark'
        : 'light'
      : colorSchemeSetting.value

  const contrast =
    contrastSetting.value === 'auto'
      ? preferredContrast.value === 'more'
        ? 'increased'
        : 'default'
      : contrastSetting.value

  return themeMap[colorScheme][contrast]
})

const disableTransitions = ref(false)

export function useTheme() {
  return {
    colorSchemeSetting,
    contrastSetting,
    theme,
    disableTransitions,
  }
}
